'use strict';

import {fnToastrFormError, printResponse} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnKubeDataFieldActions = function () {

    var tableName = '#datatable-kube-data-fields';

    if (!element_exists(tableName)) return false;

    var lang = allLangFiles.kube;
    var formsLang =allLangFiles.forms;

    moment.locale('da');
    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}});

    $(document).off('click', '#btn-create-kube-data-field');
    $(document).on('click', '#btn-create-kube-data-field', function (e) {
        e.preventDefault();

        var url = $(this).attr('data-href');

        var modalName = '#modal-create-kube-data-field';

        if (!element_exists(modalName)) {

            $.ajax({
                url: url,
                success: function (response) {

                    $('.dynamic-modal-container').append(response);

                    var modal = $(modalName);

                    modal.modal('show');

                    var form = $('#form-create-kube-data-field');

                    form.off().on('submit', function (e) {
                        e.preventDefault();

                        var formData = $(this).serialize();
                        var url = this.action;

                        $.ajax({
                            type: 'POST',
                            url: url,
                            data: formData,
                            success: function (response) {
                                if(!response.error){
                                    modal.modal('hide');
                                    $(tableName).DataTable().ajax.reload(null, false);
                                }
                                printResponse(response);
                            },
                        })
                    });

                    modal.on('hidden.bs.modal', function () {
                        modal.remove();
                    });
                }
            });
        }
    });
    $(document).off('click', tableName + ' .btn-delete');
    $(document).on('click', tableName + ' .btn-delete', function (e) {

        e.preventDefault();

        var url = $(this).attr('data-href');

        $.confirm({
            title: lang.delete.title,
            content: lang.delete.content,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {

                        $.ajax({
                            method: 'DELETE',
                            url: url,
                            success: function (response) {
                                console.log(response);

                                printResponse(response);
                                $(tableName).DataTable().ajax.reload(null, false)
                            },
                            error: fnToastrFormError,
                        });
                    },
                    text: formsLang.yes_no[1]
                },
                Nej: {
                    text: formsLang.yes_no[0]
                }
            }
        });
    });

    $(document).off('click', tableName + ' .btn-edit');
    $(document).on('click', tableName + ' .btn-edit', function (e) {

        e.preventDefault();

        var url = $(this).attr('data-href');
        var modalName = '#modal-update-kube-data-field';

        if (!element_exists(modalName)) {

            $.ajax({
                url: url,
                success: function (response) {

                    $('.dynamic-modal-container').append(response);

                    var modal = $(modalName);

                    modal.modal('show');

                    var form = $('#form-update-kube-data-field');

                    form.off().on('submit', function (e) {
                        e.preventDefault();

                        var formData = $(this).serialize();
                        var url = this.action;

                        $.ajax({
                            type: 'POST',
                            url: url,
                            data: formData,
                            success: function (response) {
                                if(!response.error){
                                    modal.modal('hide');
                                    $(tableName).DataTable().ajax.reload(null, false);
                                }
                                printResponse(response);
                            },
                        })
                    });

                    modal.on('hidden.bs.modal', function () {
                        modal.remove();
                    });
                }
            });
        }
    });
};